module.exports = __webpack_public_path__ + "img/36ba353.jpg";